import React, { useRef } from "react";
import "./App.scss";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import { observer } from "mobx-react";
import { firebaseConfig, getUserStore } from "./data/DataStores";

import LassoMVPLoginPage from "./MVP/pages/LassoMVPLoginPage";
import LassoMVPLandingPage from "./MVP/pages/LassoMVPLandingPage";
import LassoMVPOrganizationSettingsPage from "./MVP/pages/LassoMVPOrganizationSettingsPage";
import LassoTopBar from "./MVP/components/LassoTopBar";

import { FirebaseAppProvider, FirestoreProvider, useFirebaseApp } from "reactfire";
import { getFirestore } from "firebase/firestore";

import EstimaticsProjectPage from "./MVP/pages/EstimaticsProjectPage";
import Analytics from "./utils/Analytics";
import { logDebug } from "./shared/common/logger";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App: React.FC = observer(() => {
	// TOOD :: set up runtime config for dev/prod/debug
	// const firestore = useRef(getFirestore(useFirebaseApp(), (location.href.includes('localhost') && !location.href.includes('disable-dev-private')) ? 'estimatics-dev-private' : ''));
	const firestore = useRef(getFirestore(useFirebaseApp()));
	const analytics = useRef(Analytics.getInstance());
	const firestoreInstance = firestore.current;
	const userStore = getUserStore();
	// logDebug('firestore', firestoreInstance);
	if (!userStore.appReady) {
		return <div>Loading App...</div>;
	}
	return (
		<FirestoreProvider sdk={firestoreInstance}>
			{userStore.user ? (
				<div>
					<BrowserRouter>
						<LassoTopBar />
						<div className="m-8">
							<Routes>
								<Route path="/organizations/:organizationId" element={<LassoMVPOrganizationSettingsPage />} />
								<Route path="/projects/:estimateId" element={<EstimaticsProjectPage />} />
								<Route path="*" element={<LassoMVPLandingPage />} />
							</Routes>
						</div>
					</BrowserRouter>
				</div>
			) : (
				<LassoMVPLoginPage />
			)}
			<ToastContainer
				toastClassName="w-[450px] left-[-50%]"
				position="top-right"
				autoClose={2000}
				hideProgressBar
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss={false}
				draggable={false}
				pauseOnHover={false}
				theme="light"
			/>
			<div className="fixed top-0 right-0 text-xs text-gray-500 opacity-5">v0.1.0</div>
		</FirestoreProvider>
	);
});

const FirebaseApp: React.FC = () => {
	return (
		<FirebaseAppProvider firebaseConfig={firebaseConfig}>
			<App />
		</FirebaseAppProvider>
	);
};

export default FirebaseApp;
